/*
 * @Author: cheesekun
 * @Date: 2021-03-24 15:14:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-28 10:02:55
 * @FilePath: \dc-vizier-tpl-h5\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import '@/core'
import '../scripts/version'
import '@/styles/index.less'
import Vconsole from 'vconsole'
import localStorage from '@/utils/localStorage'
import router from './router'
import i18n from './i18n'
import store from './store/index.js'
window._localStorage = localStorage
if (process.env.VUE_APP_ENV === 'sit') {
  /* eslint-disable-next-line */
  new Vconsole()
}

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
